// export const baseURL = 'http://127.0.0.1:9999'
export const baseURL = 'http://gtserver.xmguitian.com:8092/gtserver-api'
